import { Box, Card, Grid, Typography } from "@mui/material";
import { useIntl } from "react-intl";
import moment from "moment";
import { useLoading } from "../../../components/LoadingContext";

const QCDataHeader = (props) => {

    const intl = useIntl();
    const { setLoading } = useLoading();

    return (
      <Box>
          <Card sx={{ p: 0.5, bgcolor: "#C0C0C0" }} id="QCheaderTable">
            <Grid container>
              <Grid item sm={1} sx={{ borderRight: "2px solid white" }}>
                  <Typography variant="subtitle1" sx={{ color: "white", ml: 1 }}>
                    {intl.formatMessage({ id: "Article.Article" })}
                  </Typography>
              </Grid>
              <Grid item sm={1} sx={{ borderRight: "2px solid white" }}>
                  <Typography variant="subtitle1" sx={{ color: "white", ml: 1 }}>
                    {intl.formatMessage({ id: "General.Barcode" })}
                  </Typography>
                  <Typography variant="subtitle2" sx={{ ml: 1 }}>
                    {props.article?.barcode}{props.article?.checkDigit}
                  </Typography>
              </Grid>
              <Grid item sm={2} sx={{ borderRight: "2px solid white" }}>
                  <Typography variant="subtitle1" sx={{ color: "white", ml: 1 }}>
                    {intl.formatMessage({ id: "General.Description" })}
                  </Typography>
                  <Typography variant="subtitle2" sx={{ ml: 1 }}>
                    {props.article?.articleDescription}
                  </Typography>
              </Grid>
              <Grid item sm={0.5} sx={{ borderRight: "2px solid white" }}>
                <Typography variant="subtitle1" sx={{ color: "white", ml: 1 }}>
                  {intl.formatMessage({ id: "BoxInDetails.Quantity" })}
                </Typography>
                <Typography variant="subtitle2" sx={{ ml: 1 }}>
                  {props.quantity}
                </Typography>
              </Grid>
              <Grid item sm={2} sx={{ borderRight: "2px solid white" }}>
                <Typography variant="subtitle1" sx={{ color: "white", ml: 1 }}>
                  {intl.formatMessage({ id: "RA.Key" })}
                </Typography>
                <Typography variant="subtitle2" sx={{ ml: 1 }}>
                  {props.head?.returnFileKey}
                </Typography>
              </Grid>
              <Grid item sm={1} sx={{ borderRight: "2px solid white" }}>
                <Typography variant="subtitle1" sx={{ color: "white", ml: 1 }}>
                {intl.formatMessage({ id: "RA.Date" })}
                </Typography>
                <Typography variant="subtitle2" sx={{ ml: 1 }}>
                  {moment(props.head?.rfDate).format("YYYY-MM-DD")}
                </Typography>
              </Grid>
              <Grid item sm={2} sx={{ borderRight: "2px solid white" }}>
                <Typography variant="subtitle1" sx={{ color: "white", ml: 1 }}>
                  {intl.formatMessage({ id: "General.Type" })}
                </Typography>
                <Typography variant="subtitle2" sx={{ ml: 1 }}>
                  {props.head?.rfType}
                </Typography>
              </Grid>
              <Grid item sm={1} sx={{ borderRight: "2px solid white" }}>
                <Typography variant="subtitle1" sx={{ color: "white", ml: 1 }}>
                {intl.formatMessage({ id: "RA.Reason" })}
                </Typography>
                <Typography variant="subtitle2" sx={{ ml: 1 }}>
                  {props.head?.reasonDescr}
                </Typography>
              </Grid>
              <Grid item sm={1.5} sx={{ borderRight: "2px solid white" }}>
                <Typography variant="subtitle1" sx={{ color: "white", ml: 1 }}>
                {intl.formatMessage({ id: "RA.ReconditionType" })}
                </Typography>
                <Typography variant="subtitle2" sx={{ ml: 1 }}>
                  {props.head?.reconditionTypeDescr}
                </Typography>
              </Grid>
            </Grid>
          </Card>

      </Box>
        
    )
}

export default QCDataHeader;